/**
 * City to State Code Mapping
 * State codes:
 * 1 - Jammu and Kashmir
 * 2 - Himachal Pradesh
 * 3 - Punjab
 * 4 - Chandigarh
 * 5 - Uttarakhand
 * 6 - Haryana
 * 7 - Delhi
 * 8 - Rajasthan
 * 9 - Uttar Pradesh
 * 10 - Bihar
 * 13 - Nagaland
 * 14 - Manipur
 * 15 - Mizoram
 * 16 - Tripura
 * 17 - Meghalaya
 * 18 - Assam
 * 19 - West Bengal
 * 20 - Jharkhand
 * 21 - Odisha
 * 22 - Chhattisgarh
 * 23 - Madhya Pradesh
 * 24 - Gujarat
 * 27 - Maharashtra
 * 28 - Andhra Pradesh / Telangana
 * 29 - Karnataka
 * 32 - Kerala
 * 33 - Tamil Nadu
 * 34 - Puducherry
 * 35 - Andaman and Nicobar Islands
 */

// Common city name aliases
const CITY_ALIASES = {
  'Mumbai': 'GreaterMumbai',
  'Hyderabad': 'GreaterHyderabad',
  'Noida': 'GreaterNoida',
  'Howrah': 'Haora',
  'Bangalore': 'Bengaluru',
  'Calcutta': 'Kolkata',
  'Calicut': 'Kozhikode',
  'Cochin': 'Kochi',
  'Trivandrum': 'Thiruvananthapuram',
  'Trichy': 'Tiruchirappalli',
  'Madras': 'Chennai',
  'Pondicherry': 'Puducherry',
  'Hardwar': 'Haridwar',
}

export const CITY_STATE_MAP = {
  Abohar: 3,
  Achalpur: 27,
  Adilabad: 28,
  Adityapur: 20,
  Adoni: 28,
  Agartala: 16,
  Agra: 9,
  Ahmedabad: 24,
  Ahmadnagar: 27,
  Aizawl: 15,
  Ajmer: 8,
  Akbarpur: 9,
  Akola: 27,
  Alandur: 33,
  Alappuzha: 32,
  Aligarh: 9,
  Allahabad: 9,
  Alwar: 8,
  Ambala: 6,
  AmbalaSadar: 6,
  Ambarnath: 27,
  Ambattur: 33,
  Ambikapur: 22,
  Ambur: 33,
  Amravati: 27,
  Amreli: 24,
  Amritsar: 3,
  Amroha: 9,
  Anand: 24,
  Anantapur: 28,
  Anantnag: 1,
  Arrah: 10,
  Asansol: 19,
  AshoknagarKalyangarh: 19,
  Aurangabad: 10,
  AurangabadMaharashtra: 27,
  Avadi: 33,
  Azamgarh: 9,
  Badlapur: 27,
  Bagaha: 10,
  Bagalkot: 29,
  Bahadurgarh: 6,
  Baharampur: 19,
  Bahraich: 9,
  Baidyabati: 19,
  BaleshwarTown: 21,
  Ballia: 9,
  Bally: 19,
  BallyCity: 19,
  Balurghat: 19,
  Banda: 9,
  Bankura: 19,
  Bansberia: 19,
  Banswara: 8,
  Baran: 8,
  Baranagar: 19,
  Barasat: 19,
  Baraut: 9,
  Barddhaman: 19,
  Bareilly: 9,
  BaripadaTown: 21,
  Barnala: 3,
  Barrackpur: 19,
  Barshi: 27,
  Basirhat: 19,
  Basti: 9,
  Batala: 3,
  Bathinda: 3,
  Beawar: 8,
  Begusarai: 10,
  Belgaum: 29,
  Bellary: 29,
  Bengaluru: 29,
  Bettiah: 10,
  Betul: 23,
  Bhadrak: 21,
  Bhadravati: 29,
  Bhadreswar: 19,
  Bhagalpur: 10,
  BhalswaJahangirPur: 7,
  Bharatpur: 8,
  Bharuch: 24,
  Bhatpara: 19,
  Bhavnagar: 24,
  BhilaiNagar: 22,
  Bhilwara: 8,
  Bhimavaram: 28,
  Bhind: 23,
  Bhiwadi: 8,
  Bhiwandi: 27,
  Bhiwani: 6,
  Bhopal: 23,
  BhubaneswarTown: 21,
  Bhuj: 24,
  Bhusawal: 27,
  Bid: 27,
  Bidar: 29,
  BidhanNagar: 19,
  Biharsharif: 10,
  Bijapur: 29,
  Bikaner: 8,
  Bilaspur: 22,
  BokaroSteelCity: 20,
  Bongaon: 19,
  Botad: 24,
  BrahmapurTown: 21,
  Budaun: 9,
  Bulandshahr: 9,
  Bundi: 8,
  Burari: 7,
  Burhanpur: 23,
  Buxar: 10,
  Champdani: 19,
  Chandannagar: 19,
  Chandausi: 9,
  Chandigarh: 4,
  Chandrapur: 27,
  Chapra: 10,
  Chas: 20,
  Chennai: 33,
  Chhattarpur: 23,
  Chhindwara: 23,
  Chikmagalur: 29,
  Chilakaluripet: 28,
  Chitradurga: 29,
  Chittaurgarh: 8,
  Chittoor: 28,
  Churu: 8,
  Coimbatore: 33,
  Cuddalore: 33,
  Cuttack: 21,
  Dabgram: 19,
  DalloPura: 7,
  Damoh: 23,
  Darbhanga: 10,
  Darjiling: 19,
  Datia: 23,
  Davanagere: 29,
  Deesa: 24,
  Dehradun: 5,
  Dehri: 10,
  Delhi: 7,
  DelhiCantonment: 7,
  Deoghar: 20,
  Deoli: 7,
  Deoria: 9,
  Dewas: 23,
  Dhanbad: 20,
  Dharmavaram: 28,
  Dhaulpur: 8,
  Dhule: 27,
  Dibrugarh: 18,
  Dimapur: 13,
  DinapurNizamat: 10,
  Dindigul: 33,
  DumDum: 19,
  Durg: 22,
  Durgapur: 19,
  Eluru: 28,
  EnglishBazar: 19,
  Erode: 33,
  Etah: 9,
  Etawah: 9,
  Faizabad: 9,
  Faridabad: 6,
  FarrukhabadcumFatehgarh: 9,
  Fatehpur: 9,
  Firozabad: 9,
  Firozpur: 3,
  GadagBetigeri: 29,
  Gandhidham: 24,
  Gandhinagar: 24,
  Ganganagar: 8,
  GangapurCity: 8,
  Gangawati: 29,
  Gaya: 10,
  Ghazipur: 9,
  Giridih: 20,
  Godhra: 24,
  GokalPur: 7,
  Gonda: 9,
  Gondal: 24,
  Gondiya: 27,
  Gorakhpur: 9,
  GreaterHyderabad: 28,
  GreaterMumbai: 27,
  GreaterNoida: 9,
  Gudivada: 28,
  Gulbarga: 29,
  Guna: 23,
  Guntakal: 28,
  Guntur: 28,
  Gurugram: 6,
  Guwahati: 18,
  Gwalior: 23,
  Habra: 19,
  Hajipur: 10,
  Haldia: 19,
  'Haldwani cumKathgodam': 5,
  Halisahar: 19,
  Hanumangarh: 8,
  Haora: 19,
  Hapur: 9,
  Hardoi: 9,
  Hardwar: 5,
  Hassan: 29,
  Hastsal: 7,
  Hathras: 9,
  Hazaribag: 20,
  Hindaun: 8,
  Hindupur: 28,
  Hinganghat: 27,
  Hisar: 6,
  Hoshangabad: 23,
  Hoshiarpur: 3,
  Hospet: 29,
  Hosur: 33,
  HubliDharwad: 29,
  HugliChinsurah: 19,
  Ichalkaranji: 27,
  Imphal: 14,
  Indore: 23,
  Jabalpur: 23,
  Jagadhri: 6,
  Jagdalpur: 22,
  Jaipur: 8,
  Jalandhar: 3,
  Jalgaon: 27,
  Jalna: 27,
  Jalpaiguri: 19,
  Jamalpur: 10,
  Jammu: 1,
  Jamnagar: 24,
  Jamshedpur: 20,
  Jamuria: 19,
  Jaunpur: 9,
  Jehanabad: 10,
  JetpurNavagadh: 24,
  Jhansi: 9,
  Jhunjhunun: 8,
  Jind: 6,
  Jodhpur: 8,
  Junagadh: 24,
  Kadapa: 28,
  Kaithal: 6,
  Kakinada: 28,
  Kalol: 24,
  Kalyani: 19,
  Kamarhati: 19,
  Kancheepuram: 33,
  Kanchrapara: 19,
  Kanpur: 9,
  KanpurCity: 9,
  Karaikkudi: 33,
  KarawalNagar: 7,
  Karimnagar: 28,
  Karnal: 6,
  Kasganj: 9,
  Kashipur: 5,
  Katihar: 10,
  Khammam: 28,
  Khandwa: 23,
  Khanna: 3,
  Kharagpur: 19,
  Khardaha: 19,
  Khargone: 23,
  Khora: 9,
  Khurja: 9,
  KirariSulemanNagar: 7,
  Kishanganj: 10,
  Kishangarh: 8,
  Kochi: 32,
  Kolar: 29,
  Kolhapur: 27,
  Kolkata: 19,
  Kollam: 32,
  Korba: 22,
  Kota: 8,
  Kozhikode: 32,
  Krishnanagar: 19,
  Kulti: 19,
  Kumbakonam: 33,
  Kurichi: 33,
  Kurnool: 28,
  Lakhimpur: 9,
  Lalitpur: 9,
  Latur: 27,
  Loni: 9,
  Lucknow: 9,
  Ludhiana: 3,
  Machilipatnam: 28,
  Madanapalle: 28,
  Madavaram: 33,
  Madhyamgram: 19,
  Madurai: 33,
  Mahbubnagar: 28,
  Mahesana: 24,
  Maheshtala: 19,
  Mainpuri: 9,
  Malegaon: 27,
  Malerkotla: 3,
  Mandoli: 7,
  Mandsaur: 23,
  Mandya: 29,
  Mangalore: 29,
  Mango: 20,
  Mathura: 9,
  MaunathBhanjan: 9,
  Medinipur: 19,
  Meerut: 9,
  MiraBhayander: 27,
  Miryalaguda: 28,
  MirzapurcumVindhyachal: 9,
  Modinagar: 9,
  Moga: 3,
  Moradabad: 9,
  Morena: 23,
  Morvi: 24,
  Motihari: 10,
  Mughalsarai: 9,
  Muktsar: 3,
  Munger: 10,
  Murwara: 23,
  Mustafabad: 7,
  Muzaffarnagar: 9,
  Muzaffarpur: 10,
  Mysore: 29,
  Nabadwip: 19,
  Nadiad: 24,
  Nagaon: 18,
  Nagapattinam: 33,
  Nagaur: 8,
  Nagda: 23,
  Nagercoil: 33,
  Nagpur: 27,
  Naihati: 19,
  Nalgonda: 28,
  NandedWaghala: 27,
  Nandurbar: 27,
  Nandyal: 28,
  NangloiJat: 7,
  Narasaraopet: 28,
  Nashik: 27,
  NaviMumbai: 27,
  NaviMumbaiPanvelRaigarh: 27,
  Navsari: 24,
  Neemuch: 23,
  Nellore: 28,
  NewDelhi: 7,
  Neyveli: 33,
  Nizamabad: 28,
  Noida: 9,
  NorthBarrackpur: 19,
  NorthDumDum: 19,
  Ongole: 28,
  Orai: 9,
  Osmanabad: 27,
  Ozhukarai: 34,
  Palakkad: 32,
  Palanpur: 24,
  Pali: 8,
  Pallavaram: 33,
  Palwal: 6,
  Panchkula: 6,
  Panihati: 19,
  Panipat: 6,
  Panvel: 27,
  Parbhani: 27,
  Patan: 24,
  Pathankot: 3,
  Patiala: 3,
  Patna: 10,
  Pilibhit: 9,
  PimpriChinchwad: 27,
  Pithampur: 23,
  Porbandar: 24,
  PortBlair: 35,
  Proddatur: 28,
  Puducherry: 34,
  Pudukkottai: 33,
  Pune: 27,
  Puri: 21,
  Purnia: 10,
  Puruliya: 19,
  RaeBareli: 9,
  Raichur: 29,
  Raiganj: 19,
  Raigarh: 22,
  Raipur: 22,
  Rajahmundry: 28,
  Rajapalayam: 33,
  RajarhatGopalpur: 19,
  Rajkot: 24,
  Rajnandgaon: 22,
  RajpurSonarpur: 19,
  Ramagundam: 28,
  Rampur: 9,
  Ranchi: 20,
  Ranibennur: 29,
  Raniganj: 19,
  Ratlam: 23,
  RaurkelaIndustrialTownship: 21,
  RaurkelaTown: 21,
  Rewa: 23,
  Rewari: 6,
  Rishra: 19,
  RobertsonPet: 29,
  Rohtak: 6,
  Roorkee: 5,
  Rudrapur: 5,
  SASNagar: 3,
  Sagar: 23,
  Saharanpur: 9,
  Saharsa: 10,
  Salem: 33,
  Sambalpur: 21,
  Sambhal: 9,
  SangliMirajKupwad: 27,
  Santipur: 19,
  Sasaram: 10,
  Satara: 27,
  Satna: 23,
  SawaiMadhopur: 8,
  Secunderabad: 28,
  Sehore: 23,
  Seoni: 23,
  Serampore: 19,
  Shahjahanpur: 9,
  Shamli: 9,
  Shikohabad: 9,
  Shillong: 17,
  Shimla: 2,
  Shimoga: 29,
  Shivpuri: 23,
  Sikar: 8,
  Silchar: 18,
  Siliguri: 19,
  Singrauli: 23,
  Sirsa: 6,
  Sitapur: 9,
  Siwan: 10,
  Solapur: 27,
  Sonipat: 6,
  SouthDumDum: 19,
  Srikakulam: 28,
  Srinagar: 1,
  Sujangarh: 8,
  SultanPurMajra: 7,
  Sultanpur: 9,
  Surat: 24,
  Suryapet: 28,
  Tadepalligudem: 28,
  Tadpatri: 28,
  Tambaram: 33,
  Tenali: 28,
  Thane: 27,
  Thanesar: 6,
  Thanjavur: 33,
  Thiruvananthapuram: 32,
  Thoothukkudi: 33,
  Thrissur: 32,
  Tiruchirappalli: 33,
  Tirunelveli: 33,
  Tirupati: 28,
  Tiruppur: 33,
  Tiruvannamalai: 33,
  Tiruvottiyur: 33,
  Titagarh: 19,
  Tonk: 8,
  Tumkur: 29,
  Udaipur: 8,
  Udgir: 27,
  Udupi: 29,
  Ujjain: 23,
  Ulhasnagar: 27,
  Uluberia: 19,
  Unnao: 9,
  UttarparaKotrung: 19,
  Vadodara: 24,
  Valsad: 24,
  Varanasi: 9,
  VasaiVirarCity: 27,
  Vellore: 33,
  Veraval: 24,
  Vidisha: 23,
  Vijayawada: 28,
  Visakhapatnam: 28,
  Vizianagaram: 28,
  Warangal: 28,
  Wardha: 27,
  Yamunanagar: 6,
  Yavatmal: 27,
}

/**
 * Get state code for a city name (case-insensitive)
 */
export const getCityStateCode = (cityName) => {
  if (!cityName) return null
  
  // Check aliases first
  const alias = CITY_ALIASES[cityName] || CITY_ALIASES[cityName.charAt(0).toUpperCase() + cityName.slice(1).toLowerCase()]
  if (alias && CITY_STATE_MAP[alias]) {
    return CITY_STATE_MAP[alias]
  }
  
  // Normalize: remove extra spaces, convert to title case
  const normalize = (name) => {
    return name
      .trim()
      .split(/[\s-]+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('')
  }
  
  const normalized = normalize(cityName)
  
  // Try exact match first
  if (CITY_STATE_MAP[normalized]) {
    return CITY_STATE_MAP[normalized]
  }
  
  // Try variations
  const variations = [
    normalized,
    cityName.charAt(0).toUpperCase() + cityName.slice(1).toLowerCase(),
    cityName.toLowerCase(),
    cityName.toUpperCase(),
    cityName.replace(/\s+/g, ''),
    cityName.replace(/\s+/g, '-'),
  ]
  
  for (const variant of variations) {
    if (CITY_STATE_MAP[variant]) {
      return CITY_STATE_MAP[variant]
    }
  }
  
  // Try partial match (for cases like "Greater Mumbai" -> "Mumbai")
  const cityKeys = Object.keys(CITY_STATE_MAP)
  for (const key of cityKeys) {
    const keyLower = key.toLowerCase().replace(/greater|city|town|nagar|pur/g, '').trim()
    const cityLower = cityName.toLowerCase().replace(/greater|city|town|nagar|pur/g, '').trim()
    if (keyLower === cityLower || 
        key.toLowerCase().includes(cityName.toLowerCase()) || 
        cityName.toLowerCase().includes(key.toLowerCase())) {
      return CITY_STATE_MAP[key]
    }
  }
  
  return null
}

/**
 * Get all cities in the same state
 */
export const getCitiesInSameState = (cityName, excludeCity = null) => {
  const stateCode = getCityStateCode(cityName)
  if (!stateCode) return []
  
  const cities = Object.entries(CITY_STATE_MAP)
    .filter(([city, code]) => code === stateCode && city !== excludeCity)
    .map(([city]) => city)
    .sort()
  
  return cities
}

/**
 * Get popular cities (major cities) in the same state
 */
export const getPopularCitiesInState = (cityName, excludeCity = null, limit = 20) => {
  const stateCode = getCityStateCode(cityName)
  if (!stateCode) return []
  
  // Major cities by state (you can customize this list)
  const majorCities = {
    24: ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Gandhinagar', 'Anand', 'Navsari', 'Bharuch', 'Botad', 'Gandhidham', 'Junagadh', 'Palanpur', 'Patan', 'Porbandar', 'Valsad', 'Veraval', 'Kalol'],
    27: ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'AurangabadMaharashtra', 'Solapur', 'Amravati', 'Kolhapur', 'SangliMirajKupwad', 'NandedWaghala', 'Jalgaon', 'Akola', 'Latur', 'Dhule', 'Ahmednagar', 'Chandrapur', 'Parbhani', 'Ichalkaranji', 'Jalna', 'Bhusawal'],
    8: ['Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar', 'Bharatpur', 'Sikar', 'Pali', 'Tonk', 'Chittaurgarh', 'Banswara', 'Baran', 'Bundi', 'Dhaulpur', 'Hanumangarh', 'Ganganagar', 'GangapurCity'],
    9: ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Allahabad', 'Meerut', 'Ghaziabad', 'Bareilly', 'Aligarh', 'Moradabad', 'Saharanpur', 'Gorakhpur', 'Faizabad', 'Jhansi', 'Muzaffarnagar', 'Mathura', 'Rampur', 'Shahjahanpur', 'Firozabad', 'Etawah'],
    29: ['Bengaluru', 'Mysore', 'HubliDharwad', 'Mangalore', 'Belgaum', 'Gulbarga', 'Davangere', 'Bellary', 'Bijapur', 'Shimoga', 'Tumkur', 'Raichur', 'Bidar', 'Hospet', 'GadagBetigeri', 'Bagalkot', 'Chitradurga', 'Kolar', 'Mandya', 'Udupi'],
    28: ['Hyderabad', 'Visakhapatnam', 'Vijayawada', 'Guntur', 'Warangal', 'Rajahmundry', 'Nellore', 'Kurnool', 'Kakinada', 'Tirupati', 'Kadapa', 'Anantapur', 'Eluru', 'Nizamabad', 'Karimnagar', 'Ramagundam', 'Mahbubnagar', 'Nalgonda', 'Adoni', 'Chilakaluripet'],
    33: ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Erode', 'Thanjavur', 'Tiruppur', 'Dindigul', 'Thoothukkudi', 'Nagercoil', 'Kanchipuram', 'Kumbakonam', 'Cuddalore', 'Karaikkudi', 'Neyveli', 'Tambaram', 'Ambattur', 'Avadi'],
    19: ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Bardhaman', 'Malda', 'Baharampur', 'Krishnanagar', 'Raiganj', 'Jalpaiguri', 'Baranagar', 'BidhanNagar', 'EnglishBazar', 'Bally', 'Kamarhati', 'Halisahar', 'Santipur', 'Kalyani', 'Bansberia'],
    23: ['Bhopal', 'Indore', 'Gwalior', 'Jabalpur', 'Ujjain', 'Sagar', 'Ratlam', 'Satna', 'Burhanpur', 'Murwara', 'Singrauli', 'Rewa', 'Bhind', 'Chhindwara', 'Khandwa', 'Morena', 'Khargone', 'Dewas', 'Mandsaur', 'Neemuch'],
    6: ['Gurugram', 'Faridabad', 'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar', 'Karnal', 'Panchkula', 'Sonipat', 'Bhiwani', 'Jind', 'Sirsa', 'Rewari', 'Bahadurgarh', 'Palwal', 'Thanesar', 'Jagadhri'],
    7: ['Delhi', 'NewDelhi', 'NorthDelhi', 'SouthDelhi', 'EastDelhi', 'WestDelhi'],
    5: ['Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur', 'Kashipur'],
    3: ['Amritsar', 'Ludhiana', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali', 'Pathankot', 'Hoshiarpur', 'Moga', 'Abohar', 'Batala', 'Muktsar', 'Malerkotla', 'Firozpur', 'Barnala'],
    10: ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga', 'Arrah', 'Begusarai', 'Katihar', 'Munger', 'Chhapra', 'Hajipur', 'Saharsa', 'Sasaram', 'Bettiah', 'Motihari', 'Siwan', 'Jehanabad', 'Kishanganj', 'Jamalpur'],
    20: ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribag', 'Deoghar', 'Giridih', 'Adityapur', 'Chas', 'Mango'],
    21: ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Brahmapur', 'Sambalpur', 'Puri', 'Baleshwar', 'Baripada', 'Bhadrak', 'Raurkela'],
    22: ['Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg', 'Rajnandgaon', 'Raigarh', 'Jagdalpur', 'Ambikapur'],
    32: ['Kochi', 'Thiruvananthapuram', 'Kozhikode', 'Thrissur', 'Kollam', 'Alappuzha', 'Palakkad'],
    18: ['Guwahati', 'Silchar', 'Dibrugarh', 'Nagaon'],
    1: ['Srinagar', 'Jammu', 'Anantnag'],
    2: ['Shimla'],
    4: ['Chandigarh'],
    13: ['Dimapur'],
    14: ['Imphal'],
    15: ['Aizawl'],
    16: ['Agartala'],
    17: ['Shillong'],
    34: ['Puducherry', 'Ozhukarai'],
    35: ['PortBlair'],
  }
  
  const popularCities = majorCities[stateCode] || []
  const allCities = getCitiesInSameState(cityName, excludeCity)
  
  // Filter to only include cities that exist in our map
  const filtered = popularCities
    .filter(city => allCities.includes(city) && city !== excludeCity)
    .slice(0, limit)
  
  // If we don't have enough popular cities, add more from the state
  if (filtered.length < limit) {
    const additional = allCities
      .filter(city => !filtered.includes(city))
      .slice(0, limit - filtered.length)
    filtered.push(...additional)
  }
  
  return filtered.slice(0, limit)
}

/**
 * Get a random city name from all available cities
 * @returns {string} Random city name
 */
export const getRandomCity = () => {
  const cities = Object.keys(CITY_STATE_MAP)
  if (cities.length === 0) return "Ahmedabad" // Fallback
  const randomIndex = Math.floor(Math.random() * cities.length)
  return cities[randomIndex]
}

